<template>
  <div class="content-block">
    <ResourceTypeTable @done="onDone"></ResourceTypeTable>
  </div>
</template>

<script>
import ResourceTypeTable from 'CORE/components/resource/type/table'

export default {
    name: 'ResourceTypeListView',
    components: {
        ResourceTypeTable,
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'resourceTypesList' })
        },
    },
}
</script>
